var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12452 15.2908C7.98743 15.2916 7.85154 15.2654 7.72462 15.2135C7.59771 15.1617 7.48227 15.0853 7.38494 14.9888L1.13494 8.73876C0.940929 8.54359 0.832031 8.27958 0.832031 8.00438C0.832031 7.72919 0.940929 7.46518 1.13494 7.27001L7.38494 1.02001C7.58421 0.849355 7.84054 0.760182 8.1027 0.770308C8.36487 0.780434 8.61355 0.889113 8.79907 1.07463C8.98458 1.26014 9.09326 1.50883 9.10339 1.77099C9.11352 2.03316 9.02434 2.28948 8.85369 2.48876L3.34327 7.99917L8.85369 13.5096C8.99996 13.6547 9.09993 13.8399 9.14096 14.0417C9.18198 14.2436 9.16222 14.4532 9.08418 14.6438C9.00613 14.8345 8.8733 14.9977 8.70248 15.1129C8.53167 15.228 8.33054 15.29 8.12452 15.2908Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.cef010f021cf6e5428beadf01dd63f80.svg";
export { ForwardRef as ReactComponent };